<template >
  <div id="executionCommodity" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>爬虫执行情况</el-breadcrumb-item>
      <el-breadcrumb-item>商品库执行情况</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-row class="executionPage">
        <el-col :span="15">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            今日商品库执行情况概览
          </div>
          <el-row>
            <el-col :span="8">
              <div class="fontDiv">
                <div class="fontColor">
                  今日更新链接数量
                </div>
                <div class="numStyle">
                  {{maincount}}
                </div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="fontDiv">
                <div class="fontColor">
                  当前已更新链接量
                </div>
                <div>
                  <div class="floatLeft">
                    {{mainingcount}}
                  </div>
                  <div class="floatRight" v-if="perMainingcount">
                    {{perMainingcount.toFixed(2)}}%
                  </div>
                  <div class="floatRight" v-else>
                    0%
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="fontDiv">
                <div class="fontColor">
                  剩余待更新链接量
                </div>
                <div>
                  <div class="floatLeft" >
                    {{mainremaincount}}
                  </div>
                  <div class="floatRight" v-if="perMainremaincount">
                    {{perMainremaincount.toFixed(2)}}%
                  </div>
                  <div class="floatRight" v-else>
                    0%
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :span="24">
              <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
                <div class="iconDiv">
                  .
                </div>
                今日商品库各平台执行情况
              </div>
              <div class="fontDiv2">
                <el-col :span="24">
                  <el-radio-group v-model="checkboxGroup" size="mini" @change="getdetails">
                    <el-radio-button v-for="item in platForm" :label="item.name" :key="item.calue"></el-radio-button>
                  </el-radio-group>
                </el-col>

                <el-col :span="8" class="colDiv">
                  <el-col :span="24" class="fontColor">
                    今日更新链接数量
                  </el-col>
                  <el-col :span="12" class="numStyle">
                    {{platformcount}}
                  </el-col>
                </el-col>

                <el-col :span="8" class="colDiv">
                  <el-col :span="24" class="fontColor">
                    当前已更新链接量
                  </el-col>
                  <el-col :span="12" class="numStyle">
                    {{platformingcount}}
                  </el-col>
                  <el-col :span="12" style="margin-top: 33px;" v-if="perPlatformingcount">
                    {{perPlatformingcount.toFixed(2)}}%
                  </el-col>
                  <el-col :span="12" style="margin-top: 33px;" v-else>
                    0%
                  </el-col>
                </el-col>

                <el-col :span="8" class="colDiv">
                  <el-col :span="24" class="fontColor">
                    剩余待更新链接量
                  </el-col>
                  <el-col :span="12" class="numStyle">
                    {{platformremaincount}}
                  </el-col>
                  <el-col :span="12" style="margin-top: 33px;" v-if="perPlatformremaincount">
                    {{perPlatformremaincount.toFixed(2)}}%
                  </el-col>
                  <el-col :span="12" style="margin-top: 33px;" v-else>
                    0%
                  </el-col>
                </el-col>

                <el-col :span="24">
                  <div id="chartLineBox" style="width: 100%;height: 400px;"> </div>
                </el-col>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            今日品牌更新队列情况
          </div>
          <div class="fontDiv3">
            <div class="fontColor2" v-if="members != '重复客户'">
              剩余待更新品牌数
            </div>
            <div class="fontColor2" v-else>
              重复客户数量
            </div>
            <div class="numStyle2">
              {{rankingcount}}
            </div>
            <div style="clear: both;margin-bottom: 24px;">
              <el-radio-group v-model="members" size="mini" style="clear: both;" @change="getrankingdetails">
                <el-radio-button v-for="item in userData" :label="item.name" :key="item.calue"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="height: 548px;overflow: auto;clear: both;">
              <div style="clear: both;font-size: 14px;color: #000000A5;margin-bottom: 8px;height: 22px;" v-for=" item in getrankinglist">
                <el-col :span="15" style="font-weight: 700;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                  <span v-if="item.companymemoname">
                    {{item.companymemoname}}
                  </span>
                  <span v-else>
                    {{item.companyname}}
                  </span>
                </el-col>
                <el-col :span="3">
                  {{item.platform | platformChinese}}
                </el-col>
                <el-col :span="3" style="text-align: center;">
                  {{item.updatecount}}
                </el-col>
                <el-col :span="3" style="text-align: right;" v-if="members != '重复客户'">
                  <span v-if="item.settingUpdateProgress == 1">
                    正在更新
                  </span>
                  <span v-if="item.settingUpdateProgress == 0">
                    等待
                  </span>
                </el-col>
              </div>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    data(){
      return{
        maincount: 0,
        mainingcount: 0,
        mainremaincount: 0,
        platformcount: 0,
        platformingcount: 0,
        platformremaincount: 0,
        rankingcount: 0,
        perMainingcount: 0,
        perMainremaincount: 0,
        perPlatformingcount: 0,
        perPlatformremaincount: 0,
        getbycount:[],
        getrankinglist:[],
        todayNum: 0,
        checkboxGroup: '淘宝天猫',
        members: '一般客户',
        userData: [{
          name: '一般客户',
          calue: '0'
        },{
          name: '重点客户',
          calue: '1'
        },{
          name: '重复客户',
          calue: '2'
        }],
        platForm: [{
          name: '淘宝天猫',
          calue: 'TBTM'
        },{
          name: '京东',
          calue: 'JD'
        },{
          name: '苏宁',
          calue: 'SN'
        },{
          name: '拼多多',
          calue: 'PDD'
        },{
          name: '1688',
          calue: '1688'
        },{
          name: '当当',
          calue: 'DD'
        },{
          name: '唯品会',
          calue: 'WPH'
        },{
          name: '药房网',
          calue: 'YFW'
        },{
          name: '1药城',
          calue: 'YYC'
        }
        // ,{
        //   name: 'lazada-越南',
        //   calue: 'LZDVN'
        // },{
        //   name: 'lazada-新加坡',
        //   calue: 'LZDSG'
        // },{
        //   name: 'lazada-马来西亚',
        //   calue: 'LZDMY'
        // }
      ],
        timeArr: [
          '00:00',
          '01:00',
          '02:00',
          '03:00',
          '04:00',
          '05:00',
          '06:00',
          '07:00',
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
          '22:00',
          '23:00',
        ],
      }
    },
    mounted() {
      this.getdetails()
      this.getrankingdetails()

    },
    methods:{
      getdetails() {
        console.log(this.checkboxGroup)
        let platform
        if (this.checkboxGroup) {
          for (let a in this.platForm) {
            if (this.platForm[a].name == this.checkboxGroup) {
              platform = this.platForm[a].calue
            }
          }
        }
        let params = {
          platform: platform
        }
        fetch({
          url: "hcm/iprpythonvisualization/getdetails",
          method: "get",
          noFormat: true,
          params: params,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getbycount = []
            this.maincount = res.data.maincount
            this.mainingcount = res.data.mainingcount
            this.mainremaincount = res.data.mainremaincount
            this.platformcount = res.data.platformcount
            this.platformingcount = res.data.platformingcount
            this.platformremaincount = res.data.platformremaincount
            this.getbycount = res.data.getbycount

            this.perMainingcount = this.mainingcount/this.maincount * 100
            this.perMainremaincount = this.mainremaincount/this.maincount * 100
            this.perPlatformingcount = this.platformingcount/this.platformcount * 100
            this.perPlatformremaincount = this.platformremaincount/this.platformcount * 100

            let createtime = []
            let updatefailure = []
            let updatesucceed = []
            for (let i in this.getbycount) {
              createtime.push(this.$options.filters['fullTime'](this.getbycount[i].createtime))
              updatefailure.push(this.getbycount[i].updatefailure)
              updatesucceed.push(this.getbycount[i].updatesucceed)
            }
            this.echartsLine(createtime,updatefailure,updatesucceed)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      getrankingdetails() {
        console.log(this.members)
        let numMembers
        if (this.members == '一般客户') {
          numMembers = 0
        } else if (this.members == '重点客户') {
          numMembers = 1
        } else {
          numMembers = 2
        }
        let params = {
          members: numMembers,
        }
        fetch({
          url: "hcm/iprpythonvisualization/getrankingdetails",
          method: "get",
          noFormat: true,
          params: params,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.rankingcount = res.data.rankingcount
            this.getrankinglist = []

            this.getrankinglist = res.data.getrankinglist.sort(this.compare("settingUpdateProgress"))
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 排序
      compare (prop) {
        return function (obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];if (val1 < val2) {
              return 1;
          } else if (val1 > val2) {
              return -1;
          } else {
              return 0;
          }
        }
      },
      echartsLine(createtime,updatefailure,updatesucceed) {
        console.log(updatefailure)
        console.log(updatesucceed)
        this.chartLine = echarts.init(document.getElementById('chartLineBox'));
        // 指定图表的配置项和数据
        var option = {
            tooltip: {              //设置tip提示
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {               //设置区分（哪条线属于什么）
              data:['更新条数','更新失败']
            },
            color: ['#1890ff', '#f04864'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
            xAxis: {                //设置x轴
              type: 'category',
              // boundaryGap: false,     //坐标轴两边不留白
              data: this.timeArr,
              // name: 'DATE',           //X轴 name
              // nameTextStyle: {        //坐标轴名称的文字样式
              //   color: '#00000072',
              //   fontSize: 16,
              //   padding: [0, 0, 0, 20]
              // },
              // axisLine: {             //坐标轴轴线相关设置。
              //   lineStyle: {
              //     color: '#00000072',
              //   }
              // }
            },
            yAxis: {
              // name: 'SALES VOLUME',
              // nameTextStyle: {
              //   color: '#00000072',
              //   fontSize: 16,
              //   padding: [0, 0, 10, 0]
              // },
              // axisLine: {
              //   lineStyle: {
              //     color: '#00000072',
              //   }
              // },
              type: 'value'
            },
            series: [
              {
                name: '更新条数',
                data:  updatesucceed,
                type: 'bar',
                barStyle: {                // 线条样式 => 必须使用normal属性
                  normal: {
                    color: '#1890ff',
                  }
                },
              },
              {
                name: '更新失败',
                data: updatefailure,
                type: 'bar',
                barStyle: {
                  normal: {
                    color: '#f04864',
                  }
                },
              }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
    }
  }
</script>

<style lang="scss">
  #executionCommodity{
    .executionPage {
      margin: 20px;
      .iconDiv {
        width: 5px;
        background-color: #333333;
        margin-right: 10px;
        height: 21px;
        margin-top: 4px;
      }
      .fontDiv {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        margin-right: 20px;
        height: 80px;
        margin-bottom: 20px;
      }
      .fontDiv2 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        margin-right: 20px;
        height: 520px;
        margin-bottom: 20px;
      }
      .fontDiv3 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        height: 708px;
        margin-bottom: 20px;
      }
      .colDiv {
        font-size: 14px;
        background-color: white;
        margin-top: 20px;
      }
      .fontColor {
        color: #00000072;
      }
      .numStyle {
        color: #1e1e1e;
        font-size: 24px;
        margin-top: 20px;
      }
      .fontColor2 {
        color: #00000072;
        float: left;
        margin-top: 16px;
        margin-bottom: 16px;
      }
      .numStyle2 {
        color: #1e1e1e;
        font-size: 24px;
        float: right;
        margin-top: 16px;
        margin-bottom: 16px;
      }
      .floatLeft {
        color: #1e1e1e;
        font-size: 24px;
        margin-top: 20px;
        float: left;
      }
      .floatRight {
        color: #1e1e1e;
        font-size: 16px;
        margin-top: 28px;
        float: right;
      }
    }
  }
</style>
